import { useState } from "react";
import { Loader2, Zap, ClipboardCheck, Ruler, Video } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { LOGO } from "@/components/site/assets";

const INCLUDES = [
  { icon: ClipboardCheck, text: "Full 10/20/40-yard, flying & jump testing" },
  { icon: Ruler, text: "Baseline evaluation added to your Academy profile" },
  { icon: Video, text: "On-site film + coach breakdown of your mechanics" },
];

export default function BookEvaluation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const checkout = async () => {
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key: "in_person_evaluation",
        origin_url: window.location.origin,
        metadata: { kind: "evaluation" },
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-6xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3"><img src={LOGO} alt="JJ Speed Factory" className="h-10 w-auto object-contain" /></a>
          <a href="/login" className="font-mono-accent text-xs tracking-[0.2em] uppercase text-white/60 hover:text-white transition-colors">Login</a>
        </div>
      </header>

      <section className="max-w-3xl mx-auto px-6 md:px-12 pt-20 pb-24">
        <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-4">In-Person Evaluation</p>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl mb-6">Book Your Evaluation</h1>
        <p className="text-white/60 text-lg mb-10">A complete in-person speed and power assessment at JJ Speed Factory. Secure your slot with a one-time payment.</p>

        <div className="grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10 mb-10">
          {INCLUDES.map((i) => { const Icon = i.icon; return (
            <div key={i.text} className="bg-[#0A0A0A] p-6"><Icon size={20} className="text-white/70 mb-3" /><p className="text-white/70 text-sm">{i.text}</p></div>
          ); })}
        </div>

        <div className="bg-[#121212] border border-white/10 p-8 flex flex-col sm:flex-row items-center justify-between gap-6" data-testid="evaluation-card">
          <div>
            <p className="font-display font-bold uppercase text-2xl">In-Person Athlete Evaluation</p>
            <p className="font-mono-accent text-4xl font-bold mt-2">$150<span className="text-white/40 text-base"> one-time</span></p>
          </div>
          <button data-testid="book-evaluation-btn" onClick={checkout} disabled={loading} className="inline-flex items-center gap-2 bg-white text-black font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-white/85 transition-colors disabled:opacity-60">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Zap size={16} />} {loading ? "Redirecting…" : "Pay & Book"}
          </button>
        </div>
        {error && <p data-testid="evaluation-error" className="text-sm text-red-400 border border-red-400/30 bg-red-400/5 px-4 py-3 mt-6">{error}</p>}
        <p className="text-white/30 text-xs mt-6">Secure checkout powered by Stripe. Test mode — use card 4242 4242 4242 4242.</p>
      </section>
    </div>
  );
}
